import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { MakeGoodSuggestionDetails } from './types';
const Modal = ({
  selectedRecord,
  handleCloseModal,
}: {
  selectedRecord: MakeGoodSuggestionDetails | null;
  handleCloseModal: () => void;
}) => {
  return (
    <Dialog
      open={!!selectedRecord}
      onClose={handleCloseModal}
      slotProps={{
        paper: {
          sx: {
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            maxWidth: 600,
            borderRadius: 2,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 'bold',
          fontSize: '1rem',
        }}
      >
        Recommendation reason:
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            display: 'flex',
            fontFamily: 'sans-serif',
            alignItems: 'center',
            padding: '1rem',
            backgroundColor: '#f9f9f9',
            borderRadius: '8px',
            fontSize: '0.85rem',
            boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)',
          }}
        >
          {selectedRecord?.reason || 'No reason provided'}
        </div>
        <p className="text-[12px] p-1">
          <span className="font-bold">makegood_suggestions id:</span>{' '}
          {selectedRecord?.makegood_suggestions_id}
        </p>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'flex-end' }}>
        <Button
          onClick={handleCloseModal}
          sx={{
            color: '#005cb4',
            fontWeight: '500',
            padding: '0.5rem 1.5rem',
            textTransform: 'capitalize',
            backgroundColor: '#f1f1f1',
            '&:hover': {
              backgroundColor: '#e0e0e0',
            },
            borderRadius: 1,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Modal;
